export const yaxisDataWNSTodayGraph = [
    { title: 'Power (KW)', opposite: false },
    { title: 'Irradiance (W/m²)', opposite: true }
];

export const yaxisDataZEUserTimeyGraph = [
    { title: 'Load Power (KW)', opposite: false, showEmpty: false },
    { title: 'Solar Power (KW)', opposite: false, showEmpty: false },
    { title: 'Grid Power (KW)', opposite: true, showEmpty: false }
]

export const yaxisDataZEUserTimeyGraph1 = [
    { title: 'Irradiance(w/m^2)', opposite: false, showEmpty: false },
    { title: 'Load Power (KW)', opposite: true, showEmpty: false },
    { title: 'Solar Power (KW)', opposite: false, showEmpty: false },
    { title: 'Grid Power (KW)', opposite: true, showEmpty: false },
    { title: 'DG Power (KW)', opposite: true, showEmpty: false }
]

export const yaxisDataChartOptions15 = [
    { title: 'Load Power (KW)', opposite: false, showEmpty: false },
    { title: 'Solar Power (KW)', opposite: true, showEmpty: false },
    { title: 'Grid Power (KW)', opposite: false, showEmpty: false },
    { title: 'DG Power (KW)', opposite: true, showEmpty: false }
]


export const yaxisDataChartOptions12 = [
    { title: 'Irradiance(w/m^2)', opposite: false, showEmpty: false },
    { title: 'Load Power (KW)', opposite: true, showEmpty: false },
    { title: 'Solar Power (KW)', opposite: false, showEmpty: false },
    { title: 'DG Power (KW)', opposite: true, showEmpty: false }
]